import {
  Component,
  Input
} from '@angular/core';

@Component({
  selector: 'axis-loading,[axis-loading]',
  templateUrl: './loading.html'
})
export class LoadingComponent {
  @Input() isInline = false;
  public showmessage = false;
  public data: string;
  private timer: any;

  constructor() {}

  initiateTimer(time, data) {
    this.showmessage = true;
    this.timer = setTimeout(() => {
      this.data = data;
    }, time);
  }
  stopTimer() {
    clearTimeout(this.timer);
  }
}
